<template>
    <div>
        <Multiselect
            v-bind="$attrs"
            :name="name"
            :placeholder="$attrs.placeholder ?? selectPrompt ?? undefined"
            :model-value="innerValue"
            @update:model-value="onSelectionChange"
            track-by="value"
            label="text"
            :options="options"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="false"
            :preserve-search="false" />
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import baseInputs from '@/components/mixins/BaseInputs';

export default {
    name: 'p-multiselect',
    mixins: [baseInputs],
    // Declared, so a parent's v-model listener is handled here rather than falling through
    // $attrs to vue-multiselect.
    emits: ['update:modelValue', 'input'],
    components: {
        Multiselect
    },
    props: {
        // value prop now comes from modelValue via BaseInputs mixin
        options: Array
    },
    data() {
        return {
            innerValue: []
        };
    },
    computed: {
        value() { return this.modelValue; },
    },
    watch: {
        // Immediate, so a value set before mounting shows rather than an empty box.
        value: {
            handler: function(newVal) {
                this.innerValue = newVal || [];
            },
            immediate: true
        }
    },
    methods: {
        // vue-multiselect 3 emits update:modelValue only; passed on as both events for callers of either.
        onSelectionChange(selectedOptions) {
            this.innerValue = selectedOptions;
            this.handleInput(selectedOptions);
        }
    }
};
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
@import '@/styles/app/common/variables.scss';
:deep(span.multiselect__tag ) {
    background-color: $primary;
}
:deep(.multiselect__option--highlight ) {
    background-color: $primary;
}
:deep(.multiselect__option--highlight.multiselect__option--selected ) {
    background-color: $dark;
}
:deep(.multiselect__option--highlight.multiselect__option--selected:after ) {
    background-color: $dark;
}
:deep(.multiselect__option--highlight:after ) {
    background-color: $primary;
}
:deep(.multiselect__tag-icon:after ) {
    color: $secondary;
}
:deep(.multiselect__tag-icon:hover ) {
    background-color: $primary-light;
}
:deep(div.multiselect__tags ) {
    border-radius: 0;
    // Center the placeholder, chosen value, tags and search text vertically, as the
    // sibling p-select does; the library's bottom margins push them to the top.
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 4px 40px 4px 8px;
    // Match the standard input border so the control doesn't look washed-out/disabled
    // next to sibling p-input/p-select fields (which use $input-default-border-color).
    border-color: $input-default-border-color;
}
:deep(.multiselect__tags-wrap ) {
    display: contents;
}
:deep(.multiselect__tag ) {
    margin-top: 2px;
    margin-bottom: 2px;
}
:deep(.multiselect__single ),
:deep(.multiselect__input ) {
    margin-bottom: 0;
}

:deep(.multiselect__content-wrapper ) {
    border-radius: 0;
    box-shadow: rgba(0, 0, 0, 0.176) 0px 6px 12px;
}
:deep(.multiselect__placeholder ) {
    // Use the normal body text color (not the faint placeholder gray) so an
    // unselected "All …" filter reads like a real value, matching the sibling
    // p-select dropdowns instead of looking disabled.
    color: $body-color;
    margin-bottom: 0;
    padding-top: 0;
}
</style>
